import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac263d08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "number-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberChange = _resolveComponent("NumberChange")!
  const _component_NumberUnit = _resolveComponent("NumberUnit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NumberChange, {
      data: _ctx.data,
      color: _ctx.color,
      time: _ctx.time,
      decimal: _ctx.decimal,
      comma: _ctx.comma,
      format: _ctx.format
    }, null, 8, ["data", "color", "time", "decimal", "comma", "format"]),
    _createVNode(_component_NumberUnit, {
      unit: _ctx.unit,
      unitOption: _ctx.unitOption
    }, null, 8, ["unit", "unitOption"])
  ]))
}